"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoContainer = exports.Content = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), (0, _layout.setContainer)('lg'));

exports.Container = Container;

var Content = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n"])));

exports.Content = Content;

var VideoContainer = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  padding-bottom: ", ";\n  height: 0px;\n  background: #000000;\n  pointer-events: none;\n\n  iframe {\n    position: absolute;\n    pointer-events: all !important;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n"])), function (props) {
  return props.paddingBottom;
});

exports.VideoContainer = VideoContainer;